var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layer",
    { staticClass: "opt_more_g writer_opt", attrs: { name: "user" } },
    [
      _c(
        "div",
        { staticClass: "box_opt_menu member_type" },
        [
          _c("div", { staticClass: "menu_item" }, [
            _c(
              "a",
              {
                staticClass: "link_menu",
                attrs: { href: "javascript:" },
                on: { click: _vm.goProfile }
              },
              [_vm._v("회원정보")]
            )
          ]),
          _vm._v(" "),
          _vm.canEditRolecode
            ? _c(
                "div",
                {
                  staticClass: "menu_item",
                  on: {
                    mouseenter: _vm.showCafeRoles,
                    mouseleave: _vm.hideCafeRoles
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "link_menu",
                      attrs: { href: "javascript:" }
                    },
                    [
                      _vm._v("등급변경"),
                      _c("span", { staticClass: "ico_bbs ico_view" }, [
                        _vm._v("등급메뉴")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "box_opt_menu box_opt_sub" },
                    _vm._l(_vm.cafeRoles, function(ref) {
                      var code = ref.code
                      var name = ref.name
                      return _c("div", { staticClass: "menu_item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "link_menu",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function($event) {
                                return _vm.changeCafeRole(code)
                              }
                            }
                          },
                          [_vm._v(_vm._s(name))]
                        )
                      ])
                    }),
                    0
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "menu_item" }, [
            _c(
              "a",
              {
                staticClass: "link_menu",
                attrs: { href: "javascript:" },
                on: { click: _vm.goArticle }
              },
              [_vm._v("작성글 보기")]
            )
          ]),
          _vm._v(" "),
          _vm.canSendToUser
            ? [
                _c("div", { staticClass: "menu_item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "link_menu",
                      attrs: { href: "javascript:" },
                      on: { click: _vm.sendWebMemo }
                    },
                    [_vm._v("쪽지 보내기")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "menu_item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "link_menu",
                      attrs: { href: "javascript:" },
                      on: { click: _vm.sendEmail }
                    },
                    [_vm._v("메일 보내기")]
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }